import { createContext, useContext, useState } from "react";

const MyContext = createContext();

export const useMyContext = () => {
  return useContext(MyContext);
};

const initialState = 1;
export const MyContextProvider = (props) => {
  const [centralizedState, setCentralizedState] = useState(initialState);

  const updateStateOnClick = (value) => {
    setCentralizedState(value);
  };

  const contextValue = {
    centralizedState,
    updateStateOnClick,
  };

  return (
    <MyContext.Provider value={contextValue}>
      {props.children}
    </MyContext.Provider>
  );
};
